import { useQuery } from '@tanstack/react-query';
import { InfrastructureInstancesApi } from 'osep-generator-service-client-v1';
import { IAS_PROJECT_INSTANCE_STATE_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

const useInfraInstanceState = (instance_id: string, enabled: boolean) => {
  const { getApiConfig, axiosInstance } = useApiConfig();

  const query = useQuery({
    queryKey: [IAS_PROJECT_INSTANCE_STATE_QUERY_KEY, instance_id],
    enabled: enabled,
    queryFn: async () => {
      const config = await getApiConfig();
      const infraApi = new InfrastructureInstancesApi(
        config,
        undefined,
        axiosInstance,
      );
      const result = (
        await infraApi.getInfrastructureInstanceState(instance_id)
      ).data;

      return result;
    },
  });
  return query;
};

export default useInfraInstanceState;
